export const NAME_FORMAT_REGEX = /^[\p{L}\p{M}0-9\s\-_.'’,]*$/u;
export const NAME_WITH_SPECIAL_CHARACTERS_FORMAT_REGEX = /^[\p{L}\p{M}0-9\s\-_.",()/€%&@+'’:;*#]*$/u;
export const FIRST_NAME_MAX_LENGTH = 40;
export const LAST_NAME_MAX_LENGTH = 80;
export const FULL_NAME_MAX_LENGTH = 120;
